import { cropImage } from '~/shared/utils/image'
import type { ImageCropParams } from '~/shared/types/image-crop'

export const useCropImage = () => {
  return {
    cropImage: (path: string, params?: ImageCropParams) => cropImage(path, params),
  }
}
